import {Pipe, PipeTransform} from '@angular/core';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import {UserTimezone} from 'app/main/signing-pages/signing-page/signing-page.dto';
import * as moment from 'moment-timezone';
import {filter, map, Observable, take} from 'rxjs';


enum returnTypeEnum {
  DIFFERENCE = 'difference',
  DATE = 'date'
}

@Pipe({
  name: 'dateConversationPipe',
})

export class DateConversationPipe implements PipeTransform {
    
    private _userTimezone$ = this._sharedStoreFacade$.userTimezone$;
    constructor (private _sharedStoreFacade$: SharedStoreFacade) {}
    
    /**
     * Convert timestamp into this format 3 mon ago
     * @param timestamp 
     * @returns Date
     */
    transform(timestamp: string, returnType: string = returnTypeEnum.DIFFERENCE): Observable<string> {
      return this._userTimezone$.pipe(
        filter(timeZone => Object.keys(timeZone)?.length > 0),
        take(1),
        map((userTimeZone: UserTimezone) => {
          if(returnType === returnTypeEnum.DATE) return moment.tz(timestamp, userTimeZone?.timezone).format('YYYY-MM-DD')
          return moment.tz(timestamp, userTimeZone?.timezone).fromNow();
        })
      );
    }

}
